import { computed, observable, makeObservable } from 'mobx';
import {ClassroomRole} from '../../scenes/classroom/models/classroom-models';

interface Provider {
  readonly joined: boolean;
  readonly classroomRole: ClassroomRole;
  readonly classroomId: number;
}

class ClassroomJoinedState {
  @observable.ref
  private provider: Provider | null = null;

  constructor() {
    makeObservable(this);
  }

  setProvider(provider: Provider | null) {
    this.provider = provider;
  }

  @computed
  get joined() {
    if (this.provider === null)
      return false;
    return this.provider.joined;
  }

  @computed
  get role(): ClassroomRole | null {
    if (this.provider === null)
      return null;
    return this.provider.classroomRole;
  }

  @computed
  get classroomId(): number | null {
    if (this.provider === null)
      return null;
    return this.provider.classroomId;
  }
}

export const classroomJoinedState = new ClassroomJoinedState();
